// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2gVQn","title":"Header_title__2iWt3","side":"Header_side__1A18y"};